import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { routePaths } from '../../urls'
import { fetchLmsCourses, postLmsSettings } from '../../actions'
import { useStateValue } from '@State'
import { ChooseForm } from './ChooseForm'

export const CanvasChoose = () => {
  const [state, dispatch] = useStateValue()
  const history = useHistory()

  useEffect(() => {
    fetchLmsCourses(dispatch)
  }, [])

  const updateCanvasCourseId = async courseId => {
    const result = await postLmsSettings({ canvasCoursenum: courseId }, dispatch)
    if (result) {
      history.push(routePaths.canvasCreateTool)
    }
  }

  return (
    <div className="card-myed">
      <div className="canvas-flex-wrapper">
        <div className="canvas-form-container">
          <h3>3. Choose Course</h3>
          <p>
            The list below contains Canvas course titles to which you have
            access.
          </p>
          <p>
            Please select the Canvas course that you would like to link to
            your MyEducator Smart Textbook:{' '}
            <span className="bold">{state.courseTitle}</span>.
          </p>
          <ChooseForm
            onSubmit={updateCanvasCourseId}
            courses={state.courseList}
            courseId={state.canvasCoursenum}
            formErrorMsg={state.selectErrorMsg}
          />
        </div>
        <div className="canvas-statusmarker-container">
          <img src="/static/instructor/media/canvas-logo-lms.png" />
        </div>
      </div>
    </div>
  )
}

